<template>
  <div class="app-list-items" :class="styledClass">
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="showLoadMore"  infinite-scroll-distance="30" class="container-list-item">
      <div @click="onClick($event, item)" :class="{ 'selected': selectedId == item.id }" class="list-item" v-for="item in listItems">
  <!--      <div class="list-icon">-->
  <!--        <span :class="iconClass(toShortName(item.name))">{{ toShortName(item.name) }}</span>-->
  <!--      </div>-->
        <p class="title">
          {{item.name}}
        </p>
        <span class="description align-self-end">
          <div class="financial-display">
            <div class="line-1">
              <app-icon className="mt-1" :name="icon" :type="item.total ? 'outline' : 'fill'" size="16" color="#005DCA"></app-icon>
              <span v-if="item.total">{{item.total}}</span>
              <span v-if="item.total"> / </span>
              <span>{{item.description}}</span>
            </div>
            <div class="line-2" v-if="item.total">
              <span>/ {{item.description}}</span>
            </div>
          </div>
        </span>
        <div class="badge-warning align-self-end" v-if="item.invalid_data.warning && item.invalid_data.company_situation">
          <i class="fad fa-exclamation-triangle" style="--fa-primary-color: #ffffff; --fa-secondary-color: #fd2222; --fa-secondary-opacity: 1; font-size: 10px"></i>
          {{item.invalid_data.company_situation}}
        </div>
      </div>
      <div v-if="isLoadMore" class="loading-more">
        <i class="fad fa-spinner-third fa-spin"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { PAGE_LIMIT } from '@/app-constant';
import { toShortName } from '@/utils/text';
import AppIcon from '@/components/app-icon';

export default {
  name: 'AppListItems',
  components: { AppIcon },
  props: {
    selectedId: [String, Number],
    listItems: {
      type: Array,
      default() {
        return [];
      },
    },
    icon: {
      type: String,
      default() {
        return 'wallet';
      },
    },
    styledClass: {
      type: String,
      default() {
        return '';
      },
    },
    paging: {
      type: Object,
      default() {
        return {
          page: 1,
          total: 0,
          limit: PAGE_LIMIT,
        };
      },
    },
    isLoadMore: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    showLoadMore() {
      return !(this.paging && this.paging.total > (this.paging.page * this.paging.limit));
    },
  },
  methods: {
    toShortName(name) {
      return toShortName(name);
    },
    onClick($event, item) {
      this.$emit('on-click', $event, item);
    },
    // iconClass(name) {
    //   const idx = (name[0].charCodeAt() + name[1].charCodeAt()) % 6;
    //   return `bg-random-${idx}`;
    // },
    loadMore() {
      this.$emit('on-load-more', this.paging);
    },
  },
};
</script>

<style lang="scss">
.app-list-items {
  overflow: scroll;

  @media only screen and (min-height: 1000px) {
    height: calc(83vh)
  }

  @media only screen and (min-height: 800px) and (max-height: 1000px) {
    height: calc(max(79vh, 79vh + ((1000 - 800) * 1/50)))
  }

  @media only screen and (min-height: 500px) and (max-height: 800px) {
    height: calc(max(70vh, 70vh + ((800 - 500) * 1/33.4)))
  }

  .container-list-item {
    //width: 100%;
    //height: 100%;

      .list-item {
        position: relative;
        font-size: 13px;
        display: flex;
        flex-direction: column;
        padding: .5rem;
        margin: 1rem .5rem;
        
        // Mobile responsive styles for compact display
        @media screen and (max-width: 768px) {
          padding: .3rem;
          margin: .5rem .3rem;
          font-size: 12px;
        }
        
        @media screen and (max-width: 576px) {
          padding: .25rem;
          margin: .4rem .25rem;
          font-size: 11px;
        }
        
        .title {
          color: #001D54;
          word-break: break-word;
          hyphens: auto;
          -webkit-hyphens: auto;
          -ms-hyphens: auto;
          line-height: 1.2;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          line-clamp: 4;
          -webkit-box-orient: vertical;
          max-height: 4.8em; // 4 lines * 1.2 line-height
          
          // Mobile responsive styles
          @media screen and (max-width: 768px) {
            -webkit-line-clamp: 3;
            line-clamp: 3;
            max-height: 3.6em; // 3 lines * 1.2 line-height
            font-size: 11px;
          }
          
          @media screen and (max-width: 576px) {
            -webkit-line-clamp: 3;
            line-clamp: 3;
            max-height: 3.6em; // 3 lines * 1.2 line-height
            font-size: 10px;
          }
        }
      i {
        font-size: 16px;
        margin-right: 2px;
        
        // Mobile responsive styles
        @media screen and (max-width: 768px) {
          font-size: 14px;
          margin-right: 1px;
        }
        
        @media screen and (max-width: 576px) {
          font-size: 12px;
          margin-right: 1px;
        }
      }

      .description {
        color: #005DCA;
        font-size: 12px;
        line-height: 1.1;
        
        // Mobile responsive styles for compact financial display
        @media screen and (max-width: 768px) {
          font-size: 10px;
          margin-top: .2rem;
        }
        
        @media screen and (max-width: 576px) {
          font-size: 9px;
          margin-top: .15rem;
        }
        
        .financial-display {
          // Desktop: 1 dòng
          display: flex;
          align-items: center;
          gap: .2rem;
          flex-direction: row;
          justify-content: flex-end;
          
          .line-1 {
            display: flex;
            align-items: center;
            gap: .2rem;
            white-space: nowrap;
          }
          
          .line-2 {
            // Desktop: ẩn
            display: none;
          }
          
          // Mobile: 2 dòng
          @media screen and (max-width: 768px) {
            flex-direction: column;
            align-items: flex-end;
            gap: .1rem;
            
            .line-1 {
              gap: .1rem;
              
              // Ẩn "/" và description trên mobile
              span:nth-child(3),
              span:nth-child(4) {
                display: none;
              }
            }
            
            .line-2 {
              display: block;
              white-space: nowrap;
              text-align: right;
              font-size: 10px;
            }
          }
          
          @media screen and (max-width: 576px) {
            .line-1 {
              gap: .05rem;
            }
            
            .line-2 {
              font-size: 9px;
            }
          }
        }
      }

      &:hover, &.selected {
        border-radius: .5rem;
        background-color: #DAF0FF80;
        cursor: pointer;
      }

      .badge-warning {
        margin-top: 4px;
        border: 1px solid #FDCD07;
        padding: 4px 8px;
        border-radius: 100px;
        color: #FD2222;
        font-size: 10px;
        background-color: inherit;
        
        // Mobile responsive styles
        @media screen and (max-width: 768px) {
          margin-top: 2px;
          padding: 2px 6px;
          font-size: 8px;
        }
        
        @media screen and (max-width: 576px) {
          margin-top: 1px;
          padding: 1px 4px;
          font-size: 7px;
        }
      }
    }

    .list-item:before {
      background: none;
      border-bottom: 1px solid #DBDBDB;
      content: "";
      display: block;
      position: absolute;
      top: -.5rem;
      left: 0;
      right: 0;
      bottom: -.5rem;
      pointer-events: none;
    }

    .list-icon {
      min-width: 44px;
      height: 40px;
      display: -ms-flexbox;
      display: flex;
      align-items: center;
      padding-top: 3px;

      span {
        //background: #a9d3f2;
        color: #fafafa;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        width: 32px;
        height: 32px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app-list-items/index.vue